var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24.046,
    height: 23.372,
    viewBox: "0 0 24.046 23.372",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_125",
    x: 0,
    y: 0,
    width: 24.046,
    height: 23.372,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.557
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Path_125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_125-2",
    "data-name": "Path 125",
    d: "M13.437,5.995,15.9,9.61a.172.172,0,0,0,.094.069l4.2,1.222a.173.173,0,0,1,.088.271L17.6,14.629a.173.173,0,0,0-.036.11L17.7,19.11a.172.172,0,0,1-.23.168L13.353,17.8a.18.18,0,0,0-.117,0l-4.115,1.48a.172.172,0,0,1-.23-.168l.135-4.371a.173.173,0,0,0-.036-.11L6.312,11.172A.172.172,0,0,1,6.4,10.9l4.2-1.222a.168.168,0,0,0,.094-.069l2.46-3.615a.173.173,0,0,1,.285,0",
    transform: "translate(-2.27 -1.92)",
    fill: "#ffed7f",
    stroke: "#194792",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.4d4c364b1dbb9c468b1019a969021d58.svg";
export { ForwardRef as ReactComponent };